import { useMutation } from '@tanstack/react-query';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface RefundInvoiceAmount {
  id: string;
  amount: string;
  type: 'full' | 'partial';
  note?: string;
  refundToWallet?: boolean;
  reversalTarget?: 'manual' | 'online';
  /** When true, call V2 invoice refund orchestrator. */
  isV2?: boolean;
}

export const refundInvoiceAmount = async ({
  id,
  isV2,
  ...params
}: RefundInvoiceAmount) => {
  const path = isV2
    ? `/v2/payment/refund/${id}`
    : `/payment-processor/refund/${id}`;
  const body = isV2
    ? {
        amount: Number(params.amount),
        type: params.type,
        ...(params.note ? { note: params.note } : {}),
        ...(params.reversalTarget
          ? { reversalTarget: params.reversalTarget }
          : {}),
      }
    : params;
  const response = await baseAPI.post<unknown>(path, body);
  return response.data;
};

export const useRefundInvoiceAmountMutation = () => {
  return useMutation({
    mutationFn: (params: RefundInvoiceAmount) => refundInvoiceAmount(params),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.STUDENT_PAYMENT_HISTORY],
      });

      setTimeout(() => {
        void queryClient.invalidateQueries({
          queryKey: [KEYS.STUDENT_PAYMENT_HISTORY],
        });
      }, 5000);

      // Refunds change outstanding balances → keep Dashboard V2 AR in sync
      void queryClient.invalidateQueries({
        queryKey: [KEYS.ACCOUNTS_RECEIVABLE],
      });
      void queryClient.invalidateQueries({
        queryKey: [KEYS.ACCOUNTS_RECEIVABLE_DUE_DATE_GROUPING],
      });
      void queryClient.invalidateQueries({
        queryKey: [KEYS.ACCOUNTS_RECEIVABLE_STUDENT_GROUPING],
      });
      void queryClient.invalidateQueries({
        queryKey: [KEYS.WALLET_BALANCE],
      });
      void queryClient.invalidateQueries({
        queryKey: [KEYS.PARENT_WALLET_TRANSACTIONS],
      });
    },
  });
};
